import React from 'react';
import { Helmet } from 'react-helmet';
import { getImageSrc } from '../../atoms/Image';
import { ImagesPropType } from '../../services/proptypes';
var defaultProps = {
  images: [],
  description: ''
};

var SEO = function SEO(_ref) {
  var businessName = _ref.businessName,
      pageName = _ref.pageName,
      description = _ref.description,
      images = _ref.images;
  var seoImage = images && images.length ? images[0] : null;
  var seo = {
    title: "".concat(pageName, " | ").concat(businessName),
    description: description,
    image: getImageSrc(seoImage)
  };
  return /*#__PURE__*/React.createElement(Helmet, {
    title: seo.title
  }, seo.description && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: seo.description
  }), seo.image && /*#__PURE__*/React.createElement("meta", {
    name: "image",
    content: seo.image
  }));
};

export default SEO;
SEO.defaultProps = defaultProps;